import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
import { SerializedSideEffects } from "pages/gdt/store/SideEffects";
const path = "/library/workflow_table_row/delete/";
export const workflowTableRowDeleteRows = djangoClientQueryFactory(
  {
    method: "post",
    path: path,
  },
  {
    formatInput: (params: {
      file_ids: string[];
      row_ids: string[];
      side_effects: SerializedSideEffects;
    }) => {
      return {
        body: {
          files: params.file_ids,
          rows: params.row_ids,
          side_effects: params.side_effects,
        },
      };
    },
    handleResponse: (res) => {
      assert(res.response.status === 204, `Unexpected response from ${path}`);
    },
  },
);
